export enum HTMLControlType {
  PARAGRAPH = 0,
  RADIO_BUTTONS_GROUP = 1,
  CHECKBOX_BUTTONS_GROUP = 2,
  TEXTBOX = 3,
  SELECT = 4,
}
